/* @indexer:no-export */
import * as React from 'react';
import './ThCell.css';
import { getAdditionalProps } from '../utils';
import { useMemo } from 'react';
export var getTheadThProps = getAdditionalProps('dm-table__cell dm-table__cell--header auto-table-cell-header', function (state, rowInfo, column) {
  var _ref = state.sorted[0] || {},
    id = _ref.id,
    desc = _ref.desc;
  var ariaSort = id === column.id ? desc ? 'descending' : 'ascending' : 'none';
  var sortable = typeof column.sortable === 'undefined' ? true : column.sortable;
  return {
    ariaSort: ariaSort,
    sortable: sortable,
    width: column.width
  };
});
export default function (_ref2) {
  var ariaSort = _ref2.ariaSort,
    children = _ref2.children,
    className = _ref2.className,
    sortable = _ref2.sortable,
    toggleSort = _ref2.toggleSort,
    width = _ref2.width;
  var childs = React.Children.toArray(children)[0].props.children;
  var style = useMemo(function () {
    return width ? {
      width: width
    } : undefined;
  }, [width]);
  return /*#__PURE__*/React.createElement("span", {
    role: "columnheader",
    "aria-sort": ariaSort,
    "aria-readonly": "true",
    style: style,
    className: className
  }, sortable ? /*#__PURE__*/React.createElement("button", {
    className: "dm-table__header-button auto-column-toggle",
    onClick: toggleSort
  }, childs) : childs);
}